export const GROUND_TRUTH_DEFAULTS = {
    Signal: '{"signal_id": ""}',
    "Structure ID Plate": '{"structure_id": ""}',
};

export const GROUND_TRUTH_DISPLAY_NAMES = {
    structure_id: "Structure ID",
    signal_id: "Signal ID",
};

const SLASH_COMMA_HYPHEN = /^(?=.*[/,-])[A-Z0-9]+(?:[/,-][A-Z0-9]+)*$/;

export const GROUND_TRUTH_VALIDATION = {
    structure_id: {
        regex: SLASH_COMMA_HYPHEN,
        error: "Ground truth must contain at least one slash, comma, or hyphen and only contain numbers and upper case letters eg: XX/123-YY",
    },
    signal_id: {
        regex: SLASH_COMMA_HYPHEN,
        error: "Ground truth must contain at least one slash, comma, or hyphen and only contain numbers and upper case letters eg. ZZ/123",
    },
    Signal: {
        regex: SLASH_COMMA_HYPHEN,
        error: "Signal ID must contain at least one slash, comma, or hyphen and only contain numbers and upper case letters eg: XX/123",
    },
    "Structure ID Plate": {
        regex: SLASH_COMMA_HYPHEN,
        error: "Structure ID must contain at least one slash, comma, or hyphen and only contain numbers and upper case letters eg: XX/123-YY",
    },
    Speedboard: {
        regex: /^[0-9]+$/,
        error: "Speedboard can only contain numbers eg: 60",
    },
};

/* Explanation:
^[A-Z0-9]+: Match one or more uppercase letters or digits at the beginning.
(?:\/[A-Z0-9]+)*: Non-capturing group that allows a single / followed by one or more uppercase letters or digits, repeated zero or more times.
$: Assert the end of the string.
*/

export const validateGroundTruth = (groundTruthKey, value) => {
    const regexData = GROUND_TRUTH_VALIDATION[groundTruthKey];
    if (!regexData) {
        return false;
    }

    if (!regexData.regex.test(value)) {
        return regexData.error;
    }
    return false;
};
